import { DatabaseSidebar } from 'components/Layouts/Sidebar/DatabaseSidebar';

import styles from './DatabaseLayout.module.scss';

interface ComponentProps {
  children: React.ReactNode;
}

export const DatabaseLayout = ({ children }: ComponentProps) => {
  return (
    <main className={styles.container}>
      <div>{children}</div>
      <DatabaseSidebar />
    </main>
  );
};
